module.exports = __webpack_public_path__ + "static/media/shop-history-icon.a2a0e1ce.svg";